import { isJson } from './json'

export const getErrorMessage = (error: unknown): string => {
  let message = 'Somethink went wrong.'

  if (error instanceof Error) {
    message = error.message
  } else if (error && typeof error === 'object' && error !== null && 'message' in error) {
    const errorMessage = (error as { message: unknown }).message
    if (typeof errorMessage === 'string') {
      message = errorMessage
    } else {
      message = 'The error is not of type string.'
    }
  } else if (typeof error === 'string') {
    message = error
    if (isJson(error)) {
      message = JSON.parse(error)
    }
  }

  return message
}
